import React, { useState, useCallback } from 'react';
import {
  Box,
  CardHeader,
  Checkbox,
  Grid,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
} from '@mui/material';
import { Search } from '@mui/icons-material';
import { alphabetically } from './helper';

const CustomList = ({
  handleToggle,
  handleToggleAll,
  numberOfChecked,
  title,
  checked,
  items,
  allFieldsSelected,
  primaryKeys,
  isRight,
}) => {
  const [search, setSearch] = useState('');

  const listItems = items
    .filter((item) => item.match(new RegExp(search, 'i')))
    .sort(alphabetically)
    .map((value) => {
      const labelId = `transfer-list-all-item-${value}-label`;

      return (
        <ListItem
          key={value}
          sx={{
            padding: '8px',
            '&:hover': {
              backgroundColor: ({ palette }) =>
                allFieldsSelected ? 'transparent' : (checked.indexOf(value) !== -1 ? palette.primary.dark : palette.secondary.gray),
            },
            ...(checked.indexOf(value) !== -1 && {
              backgroundColor: ({ palette }) => palette.primary.main,
              color: 'white',
            }),
            ...(allFieldsSelected && {
              opacity: 0.5,
              cursor: 'not-allowed',
            }),
          }}
          role="listitem"
          disabled={allFieldsSelected || (primaryKeys?.includes(value) && isRight)}
          button={!allFieldsSelected}
          onClick={allFieldsSelected ? undefined : handleToggle(value)}
        >
          <ListItemText
            primaryTypographyProps={{
              sx: {
                color: ({ palette }) => (checked.indexOf(value) !== -1 ? 'white' : palette.text.primary),
              },
            }}
            id={labelId}
            primary={value}
          />
        </ListItem>
      );
    });

  return (
    <Box
      display="flex"
      flex={1}
      flexDirection="column"
      minHeight={0}
      width="222px"
      sx={{
        border: ({ palette }) => `1px solid ${palette.common.outline}`,
        borderRadius: '8px',
        pt: allFieldsSelected ? 2 : 3,
        ...(allFieldsSelected && {
          opacity: 0.6,
          pointerEvents: 'none',
        }),
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems={allFieldsSelected ? 'center' : 'start'} width="100%" px={2}>
        <Box display="flex" flexDirection="column" gap={0.5}>
          <Typography variant="body1" fontWeight={500}>
            {title}
          </Typography>
          <Typography variant="body2" color="text.lightish" display={allFieldsSelected && 'none'}>
            {numberOfChecked(items)}/{items.length} selected
          </Typography>
        </Box>
        <Checkbox
          color="secondary"
          onClick={handleToggleAll(items)}
          checked={numberOfChecked(items) === items.length && items.length !== 0}
          indeterminate={numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0}
          disabled={items.length === 0 || allFieldsSelected}
          size="small"
          sx={{
            ...(allFieldsSelected && {
              padding: '4px 8px',
            }),
          }}
          inputProps={{ 'aria-label': 'all items selected' }}
        />
      </Box>
      <Box width="100%" px={2} mb={2}>
        <TextField
          variant="standard"
          sx={{
            fontSize: '12px',
            '& label': {
              fontWeight: '400',
              fontSize: '14px',
              color: 'rgba(85, 90, 100)',
            },
          }}
          label="Search fields"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          color="secondary"
          disabled={allFieldsSelected}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                <Search style={{ fill: 'rgba(85, 90, 100, 0.75) ', fontSize: '0.875rem' }} />
              </InputAdornment>
            ),
          }}
          fullWidth
        />
      </Box>
      <List
        sx={{
          paddingLeft: '16px',
          paddingRight: '16px',
          paddingTop: '0',
          overflow: 'auto',
          cursor: allFieldsSelected ? 'not-allowed' : 'pointer',
        }}
        dense
        component="div"
        role="list"
      >
        {listItems}
      </List>
    </Box>
  );
};

export default CustomList;
